export const MEDIA = process.env.VUE_APP_MEDIA_URL;
export const URL = process.env.VUE_APP_BACKEND_URL;
export const ADDRESS_API = process.env.VUE_APP_GET_ADDRESS;